// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__hMviC","col":"styles_col__1P3yZ","fulfillmentStatus":"styles_fulfillmentStatus__1bua0","emailCol":"styles_emailCol__1rR6k"};